import React from 'react';
import styled, { keyframes } from 'styled-components';
import { NoScrollBehavior } from '../../behaviours/NoScrollBehavior';
import PropTypes from 'prop-types';
var data = {
  primary: {
    bcolor: 'green50',
    color: 'green500'
  },
  gray: {
    bcolor: 'gray600',
    color: 'gray800'
  },
  white: {
    bcolor: 'gray300',
    color: 'white'
  }
};
var AgroSpinner = function AgroSpinner(_ref) {
  var width = _ref.width,
    height = _ref.height,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24px' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$disablePage = _ref.disablePage,
    disablePage = _ref$disablePage === void 0 ? false : _ref$disablePage;
  var bcolor = data[variant].bcolor;
  var color = data[variant].color;
  var spinner = /*#__PURE__*/React.createElement(StyledSvg, {
    width: width || size,
    height: height || size,
    viewBox: "0 0 24 24",
    "data-cy": "spinner"
  }, /*#__PURE__*/React.createElement(StyledBackground, {
    bcolor: bcolor,
    cx: "12",
    cy: "12",
    r: "11"
  }), /*#__PURE__*/React.createElement(StyledCircle, {
    color: color,
    cx: "12",
    cy: "12",
    r: "11"
  }));
  return disablePage ? /*#__PURE__*/React.createElement(NoScrollBehavior, null, /*#__PURE__*/React.createElement(Backdrop, null, /*#__PURE__*/React.createElement(SpinnerContainer, null, spinner))) : spinner;
};
AgroSpinner.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.oneOf(['gray', 'primary', 'white']),
  disablePage: PropTypes.bool
};
AgroSpinner.displayName = 'AgroSpinner';
export { AgroSpinner };
var rotate = keyframes(["50%{transform:rotate(180deg)}100%{transform:rotate(720deg)}"]);
var progresive = keyframes(["50%{stroke-dashoffset:0}100%{stroke-dashoffset:63}"]);
var StyledSvg = styled.svg.withConfig({
  displayName: "AgroSpinner__StyledSvg",
  componentId: "sc-1hxq0zt-0"
})(["animation:", " 1.5s linear infinite;width:", ";height:", ";"], rotate, function (_ref2) {
  var width = _ref2.width;
  return width;
}, function (_ref3) {
  var height = _ref3.height;
  return height;
});
var StyledBackground = styled.circle.withConfig({
  displayName: "AgroSpinner__StyledBackground",
  componentId: "sc-1hxq0zt-1"
})(["fill:none;stroke:", ";stroke-width:2px;"], function (_ref4) {
  var theme = _ref4.theme,
    bcolor = _ref4.bcolor;
  return theme.colors[bcolor];
});
var StyledCircle = styled.circle.withConfig({
  displayName: "AgroSpinner__StyledCircle",
  componentId: "sc-1hxq0zt-2"
})(["animation:", " 1.5s linear infinite;fill:none;stroke-dasharray:63;stroke-dashoffset:63;stroke-linecap:round;stroke-width:2px;stroke:", ";"], progresive, function (_ref5) {
  var theme = _ref5.theme,
    color = _ref5.color;
  return theme.colors[color];
});
var SpinnerContainer = styled.div.withConfig({
  displayName: "AgroSpinner__SpinnerContainer",
  componentId: "sc-1hxq0zt-3"
})(["display:flex;position:absolute;width:100%;height:100%;top:0;left:0;justify-content:center;align-items:center;"]);
var Backdrop = styled.div.withConfig({
  displayName: "AgroSpinner__Backdrop",
  componentId: "sc-1hxq0zt-4"
})(["position:fixed;left:0;top:0;width:100%;height:100%;overflow:auto;background:rgba(0,0,0,0.3);overflow-y:scroll;z-index:99999;"]);